import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import Shield from '../../../../components/Shield'
import { useTeam } from '../../data/team'

const Team = styled('div')`
    background: var(--colors-grays-0);
    display: flex;
    flex-direction: column;
    width: 100%;
    border: var(--borders-main);
    border-radius: var(--borderRadius-sm);
    padding: 0.5em;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    transition: 0.4s ease all;
    /* ${({ isActiveTeam }) =>
        isActiveTeam ? 'border-color: var(--colors-grays-60)' : ''}; */
    &:hover {
        background: var(--colors-grays-40);
    }
    span {
        margin-top: 0.5rem;
        text-align: center;
    }
`
const TeamCard = ({ team }) => {
    const navigate = useNavigate()
    const [{ activeTeam }] = useTeam()
    const isActiveTeam = activeTeam?._id === team._id
    return (
        <Team
            onClick={() =>
                team?._id &&
                navigate(`${isActiveTeam ? '/my' : ''}/teams/${team._id}`)
            }
            isActiveTeam={isActiveTeam}
        >
            <Shield
                width="1rem"
                height="1.25rem"
                primaryColor={team?.colors[0]}
                secondaryColor={team?.colors[1]}
            ></Shield>
            <span>{team?.name}</span>
        </Team>
    )
}

export default TeamCard
